/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    taskStatusData : [],
};


const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetTaskStatusAction.GET_TASK_COMPLETION_STATUS:
      return {
        ...state,
    };
    case actions.GetTaskStatusAction.TASK_COMPLETION_STATUS_RESPONSE:
          return{
      ...state,
      taskStatusData : action.data.TaskCompletionStatus,
      // userid: action.payload.user_ID,
      // projectid: action.payload.project_ID,
    };

    default:
      return state;
  }
};

export default reducer;
